import { JsonPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListComponent } from './pages/resource/list/list.component';
import { SyntaxComponent } from './pages/resource/syntax/syntax.component';

const routes: Routes = [
  {
    path: "",
    component: ListComponent,
  },
  {
     path: "list",
      component: ListComponent,
   },
   {
   path: "syntax",
   component: SyntaxComponent,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
